import { HStack, Skeleton, VStack } from '@rbilabs/universal-components';
import { spacing } from '@rbilabs/universal-components/themes';
import { StyleSheet, View } from 'react-native';

import { selectors, useAppSelector } from 'state/global-state';
import { isAnyWalmartOffer } from 'state/loyalty/hooks/utils/walmart';
import { LoyaltyOffer } from 'state/loyalty/types';
import { primitive } from 'styles/constants/primitives';

import { WalmartBadgeContainer } from './cart-item-offer';

export const CartItemOfferDiscountSkeleton = ({
  selectedLoyaltyOffer,
}: {
  selectedLoyaltyOffer: LoyaltyOffer;
}) => {
  const startEndColorProp = {
    startColor: primitive.$blackOpacity10,
    endColor: primitive.$whiteOpacity30,
  };
  const isWalmartOfferSelected = isAnyWalmartOffer(selectedLoyaltyOffer);
  const loyaltyWalmartUILoading = useAppSelector(selectors.loyalty.selectLoyaltyWalmartUILoading);
  return (
    <View style={styles.container}>
      <Skeleton rounded="full" height="$4" width="$4" {...startEndColorProp} />
      <VStack marginLeft="$2" flex={1}>
        {(isWalmartOfferSelected || loyaltyWalmartUILoading) && (
          <WalmartBadgeContainer marginBottom="$0.5" />
        )}
        <Skeleton.Text {...startEndColorProp} lines={2} space={1} />
      </VStack>
      <HStack marginLeft="$12" alignItems="center">
        <Skeleton {...startEndColorProp} width="$12" height="$5" rounded={12} />
      </HStack>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flexDirection: 'row',
    paddingVertical: spacing.$3,
    paddingHorizontal: spacing.$3,
    marginBottom: spacing.$3,
    borderRadius: 8,
    backgroundColor: primitive.$blackOpacity4,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});
